import type { FunctionComponent } from 'react';

import { RouterLink } from '@trello/router/router-link';

import type { BoardEntity } from './types';

interface BoardProps extends Pick<BoardEntity, 'id' | 'shortLink' | 'text'> {
  onClick?: () => void;
}

export const Board: FunctionComponent<BoardProps> = ({
  text,
  shortLink,
  id,
  onClick,
}) => {
  const boardUrl = `/b/${shortLink || id}`;

  return (
    <RouterLink href={boardUrl} onClick={onClick}>
      {text}
    </RouterLink>
  );
};
